import {MI} from "../init";
import WinControl from "./WinControl";
import {madnes_end_round} from "../../framework/src/engine/madnes/madnes";
import { states } from "../../framework/src/engine/madnes/madnes_variables";
import { STATES } from "../../framework/src/states/states";

/**
 * @constructor
 * @param {Game} game
 * @param {SymbolsManager} symbolsManager
 * @returns {ResultController}
 */
export default function ResultController(game, symbolsManager) {
    this._game = game;

    this._sounds = game.sounds;

    /** @type {SymbolsManager} */
    this._symbolsManager = symbolsManager;

    this._controlLinePos = 0;
    this._controlResultPos = 0;

    /** @type {?Array<ServerResultWinline>|undefined} */
    this._lineWins;

    /** @type {ServerResult} */
    this._serverResult;

    /** @type {WinControl} */
    this._winControl;

    this._roundWinTotal = 0;

    this._bigWinPlayed = false;

    this._forceAutostart = false;

    this.winAudioPos = 1;
};

/**
 * If in autostart, returns false
 * @returns {boolean}
 */
ResultController.prototype.autostartRemoveBetNextSpin = function() {
    if(this._game.isInAutostart()) {
        return false;
    } else {
        return true;
    }
};

//ResultController.prototype.init = function() {
//	this._winControl = new WinControl(this._game, this, this._symbolsManager);
//};

ResultController.prototype.incControlResultPos = function() {
    return ++this._controlResultPos;
};

/**
 * @returns {number}
 */
ResultController.prototype.getControlResultPos = function() {
    return this._controlResultPos;
};

/**
 * @returns {number}
 */
ResultController.prototype.getControlLinePos = function() {
    return this._controlLinePos;
};

/**
 * @param {boolean} b
 */
ResultController.prototype.setForceAutostart = function(b) {
    this._forceAutostart = b;
};

/** @returns {boolean} */
ResultController.prototype._isForceAutostart = function() {
    return this._forceAutostart;
};

/**
 * @param {ServerResult} serverResult
 */
ResultController.prototype.control = function(serverResult) {

    this._game.setForceAutostartEnabled(false);
    this._game.isRespin = false;

    this._winControl = new WinControl(this._game, this, serverResult, this._symbolsManager);

    this._serverResult = serverResult;
    this._lineWins = serverResult.getServerResultWinlines();

    this._controlLinePos = 0;
    this._controlResultPos = 0;

    this.winAudioPos = 1;

    this._roundWinTotal = serverResult.getLinesWinTotal();

    this._bigWinPlayed = false;

    this._controlWin();
};

/** @param {boolean=} fromBigWin */
ResultController.prototype._controlWinNext = function(fromBigWin) {
    this._controlLinePos++;
    this._controlWin(fromBigWin);
};

/** @param {boolean=} fromBigWin */
ResultController.prototype._controlWin = function(fromBigWin) {
    var _self = this;
    var winline = this._getActualLineWin();

    if(!winline || fromBigWin || !this._lineWins) {
        _self._winControl.end().then(function() {
            _self._endControl();
        });
        return;
    }

    MI.controls.hideStop();
    states.setState(STATES.SKIP)
    var control = this._winControl.init();
    this._winControl.setNextWinLine(this._getNextLineWin());
    this._winControl.run(winline, this._lineWins);

    control.then(function(data) {
        _self._controlWinNext(data && data["fromBigWin"]);
    });
};

/**
 * @param {number} index
 * @returns {ServerResultWinline|undefined}
 */
ResultController.prototype._getLineWin = function(index) {

    return this._serverResult.getServerResultWinline(index);
};

/**
 * @returns {ServerResultWinline|undefined}
 */
ResultController.prototype._getActualLineWin = function() {
    return this._getLineWin(this._controlLinePos);
};

/**
 * @returns {ServerResultWinline|undefined}
 */
ResultController.prototype._getNextLineWin = function() {
    return this._getLineWin(this._controlLinePos + 1);
};

/** @returns {number} */
ResultController.prototype._getLineWinCountLeft = function() {
    return this._lineWins ? Object.keys(this._lineWins).length - this._controlLinePos : 0;
};

ResultController.prototype._endControl = function() {

    var win = this._game.getWin();

    MI.controls.winAnimReset();

    if(win > 0) {
        this._endRoundWin(win);
    } else {
        this._endRoundNoWin();
    }
};

/** @param {number} win - in `money` */
ResultController.prototype._endRoundWin = function(win) {

    // var _self = this;
    //
    // MI.recountBet(win);
    // MI.recountMoney(win, _self._game.isInAutostart());
    //
    // MI.setWin(0);
    //
    // this._endRoundServer(true).then(function() {
    //
    // 	var betRemoved = _self._game.isInAutostart();
    //
    // 	_self._recountBalance(betRemoved);
    //
    // 	_self._endResultControl(_self.autostartRemoveBetNextSpin(), betRemoved ? MI.getRealBet() : 0);
    // });

    madnes_end_round();
};

ResultController.prototype._endRoundNoWin = function() {

    // var _self = this;
    //
    // this._endRoundServer(true).then(function() {
    //
    // 	MI.controls.showAllBtns();
    // 	MI.controls.hideStop();
    //
    // 	_self._recountBalance(false);
    // 	MI.setWin(0);
    //
    // 	_self._endResultControl(true);
    // });

    madnes_end_round();
};

// /**
//  * @param {boolean} enableRemoveBet
//  * @param {number=} addMoney
//  */
// ResultController.prototype._endResultControl = function(enableRemoveBet, addMoney) {
//
// 	MI.controls.showAllBtns();
//
// 	addMoney = addMoney ? addMoney : 0;
// 	MI.recountBet(addMoney);
//
// 	this._game.bonus.checkEnd();
// //	this._game.wild.checkWild(true);
//
// 	this._game.enableRemoveBet(enableRemoveBet);
//
// 	this._game.lastRoundEnded = true;
// 	this._game.spinEnabled = true;
//
// 	this._game.setForceAutostartEnabled(false);
//
// 	setTimeout(function() {
// 		this._endResultControlAutostart(addMoney);
// 	}.bind(this), this._game.isInAutostart() ? this._game.gameCfg.autoStartDelay : 0);
// };
//
// /**
//  * @param {number=} addMoney
//  */
// ResultController.prototype._endResultControlAutostart = function(addMoney) {
//
// 	if(this._game.isInAutostart() || this._isForceAutostart()) {
//
// 		MI.controls.hideSpin();
// 		this.setForceAutostart(false);
//
// 		if(this._game.inFreeSpins) {
//
// 			this._game.spinStart();
//
// 		} else {
//
// 			if(!MI.checkMoney(addMoney)) {
// 				this._game.endAutostart();
// 			}
//
// 			MI.rotateStart();
// 		}
// 	}
// };
//
// /** @param {boolean=} removeBet */
// ResultController.prototype._recountBalance = function(removeBet) {
// 	MI.recountBalance(MI.server.getEndRoundTmp(), removeBet);
// };
//
// /**
//  * @param {boolean} ended
//  * @param {Object=} roundData
//  * @param {Object=} fsData
//  * @returns {Promise}
//  */
// ResultController.prototype._endRoundServer = function(ended, roundData, fsData) {
// //	MI.controls.showStop();
// //	MI.controls.hideSpin();
// 	return MI.server.endRound(ended, roundData, fsData);
// };

/**
 * @param {number=} win
 * @returns {boolean}
 */
ResultController.prototype._isBigWinType = function(win) {

    if(!win) {
        return false;
    }

    var winType = this._game.getWinType(win, MI.getBet());
    if(winType >= this._game.BIG_WIN && winType <=	this._game.SUPER_MEGA_WIN) {
        return true;
    }

    return false;
};

/** @returns {boolean} */
ResultController.prototype.isBigWin = function() {

    // console.log(this._roundWinTotal, MI.getBet(), this._game.isBigWin(this._roundWinTotal, MI.getBet()));

    return this._game.isBigWin(this._roundWinTotal, MI.getBet());
};